import { useEffect, useState } from "react";
import { getProviders } from "./providers";

export interface Provider {
    id: number;
    name: string;
    uniqueName: string;
}

export const useDebouncedProviders = (currentInput: string) => {
    const [providers, setProviders] = useState<Provider[] | []>([]);

    useEffect(() => {
        if (!currentInput) {
            setProviders([]);
            return;
        }

        const timeout = setTimeout(async () => {
            try {
                const res = await getProviders({
                    params: {
                        searchTerm: currentInput,
                        pageSize: 10,
                    },
                });
                setProviders(res.data);
            } catch (error) {
                console.error("Error:", error);
            }
        }, 500);

        return () => clearTimeout(timeout);
    }, [currentInput]);

    return providers;
};
